const pendingKey = 'xprojex_open_chat_pending';
export const OPEN_ASSISTANT_EVENT = 'xprojex:open-chat';
let pending = false;

export function requestAssistantOpen() {
  pending = true;
  try { sessionStorage.setItem(pendingKey, 'true'); } catch { /* Optional across reloads. */ }
  window.dispatchEvent(new Event(OPEN_ASSISTANT_EVENT));
}

// Also preserves a click made while the lazy widget loads with storage disabled.
export function consumeAssistantOpen(): boolean {
  let requested = pending;
  pending = false;
  try {
    requested = sessionStorage.getItem(pendingKey) === 'true' || requested;
    sessionStorage.removeItem(pendingKey);
  } catch { /* The in-memory request is enough within this page. */ }
  return requested;
}
